/**
 * Parses the input value to an integer.
 *
 * @param {any} value nullish, string, or number
 * @returns {number} - parsed integer or zero
 */
const parseValue = (value) => {
  if (value == null) {
    return 0;
  }

  if (typeof value === "number" && !isNaN(value)) {
    return value;
  }

  if (typeof value === "string") {
    const parsed = parseInt(value, 10);
    if (!isNaN(parsed)) {
      return parsed;
    }
  }

  console.error(
    "parseValue could not convert to integer. Falling back to 0.",
    value
  );
  return 0;
};

export default parseValue;
